import classNames from 'classnames';
import PropTypes from 'prop-types';
import {Tooltip} from '@material-ui/core';
import {observer} from 'mobx-react';
import React, {Component} from 'react';

@observer
class MarkupIcon extends Component {
    render() {
        const {iconName, isActive, onClick, onMouseOver, onMouseLeave, iconSrc} = this.props;
        const markupIconClasses = classNames({
            'markup-icon': true,
            'active': isActive
        });

        return (
            <Tooltip title={iconName} enterDelay={300} placement='top' classes={{tooltip: 'icon-tooltip', popper: 'icon-tooltip-wrapper'}}>
                <div className={markupIconClasses}
                    onMouseOver={onMouseOver}
                    onMouseLeave={onMouseLeave}
                    onClick={onClick}>
                    <img draggable='false' src={`data:image/svg+xml;base64, ${iconSrc}`} />
                </div>
            </Tooltip>
        );
    }
}

MarkupIcon.propTypes = {
    iconSrc: PropTypes.string,
    handleCanvasImage: PropTypes.func
};

export default MarkupIcon;
